import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  height: ', 'px;\n  border-radius: ', 'px;\n  background-color: ', ';\n  font-weight: ', ';\n  color: ', ';\n  font-size: ', 'px;\n  font-family: ', ';\n  outline: none;\n  border: none;\n  box-shadow: none;\n  && {\n    cursor: ', ';\n  }\n  padding: 0;\n  position: relative;\n  width: ', ';\n  ', ';\n  ', ';\n'], ['\n  height: ', 'px;\n  border-radius: ', 'px;\n  background-color: ', ';\n  font-weight: ', ';\n  color: ', ';\n  font-size: ', 'px;\n  font-family: ', ';\n  outline: none;\n  border: none;\n  box-shadow: none;\n  && {\n    cursor: ', ';\n  }\n  padding: 0;\n  position: relative;\n  width: ', ';\n  ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      min-width: ', 'px;\n    '], ['\n      min-width: ', 'px;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 0;\n  padding: 0;\n  user-select: none;\n  display: inline-block;\n  vertical-align: middle;\n'], ['\n  margin: 0;\n  padding: 0;\n  user-select: none;\n  display: inline-block;\n  vertical-align: middle;\n']);

import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { styles } from 'gipsy-misc';
import PropTypes from 'prop-types';

var propTypes = {
  width: PropTypes.any,
  height: PropTypes.number,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string,
  fontSize: PropTypes.number,
  borderRadius: PropTypes.number,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.any.isRequired,
  iconColor: PropTypes.string,
  iconBackgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  leftIcon: PropTypes.element,
  rightIcon: PropTypes.element
};

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      if (_this.props.onClick && !_this.props.disabled) {
        _this.props.onClick();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: 'shouldComponentUpdate',

    /*
     ** We use handmade shouldComponentUpdate instead of PureComponent in order to ignore the onClick function
     ** it allows us to create a new function on every render in the parent : onClick={() => { doSomething() }}
     ** without rerendering the component everytime the parent is rendered (PureComponent have this side effect )
     */
    value: function shouldComponentUpdate(nextProps, nextState) {
      var ignores = ['onClick'];
      for (var prop in propTypes) {
        if (ignores.indexOf(prop) !== -1) {
          continue;
        }
        if (this.props[prop] !== nextProps[prop]) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          iconColor = _props.iconColor,
          iconBackgroundColor = _props.iconBackgroundColor,
          leftIcon = _props.leftIcon,
          rightIcon = _props.rightIcon,
          disabled = _props.disabled,
          height = _props.height,
          width = _props.width,
          fontWeight = _props.fontWeight,
          backgroundColor = _props.backgroundColor,
          borderRadius = _props.borderRadius,
          fontSize = _props.fontSize,
          textColor = _props.textColor,
          className = _props.className,
          style = _props.style;


      var finalWidth = width ? width === 'auto' ? width : width + 'px' : undefined;
      return React.createElement(
        Container,
        {
          disabled: disabled,
          className: className,
          height: height,
          width: finalWidth,
          fontWeight: fontWeight,
          fontSize: fontSize,
          backgroundColor: backgroundColor,
          borderRadius: borderRadius,
          textColor: textColor,
          style: style,
          onClick: this.onClick },
        leftIcon,
        React.createElement(
          Label,
          { className: 'button-label' },
          children
        ),
        rightIcon
      );
    }
  }]);

  return Button;
}(Component);

Button.propTypes = propTypes;
Button.defaultProps = {
  height: 48,
  fontWeight: 600,
  fontSize: 14,
  borderRadius: 20,
  iconColor: 'white',
  backgroundColor: styles.colors.primaryColor,
  iconBackgroundColor: 'transparent',
  textColor: 'white' };


export default Button;

var Container = styled.button(_templateObject, function (props) {
  return props.height;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.textColor;
}, function (props) {
  return props.fontSize;
}, styles.fonts.primaryFont, function (props) {
  return props.disabled ? 'initial' : 'pointer';
}, function (props) {
  return props.width ? props.width : '100%';
}, function (props) {
  return props.width && css(_templateObject2, props.width);
}, function (props) {
  return props.style;
});

var Label = styled.span(_templateObject3);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/ReusableButton/index.js
// module id = 201
// module chunks = 0